// File: MotivationalAboutSection.jsx
// Dark theme + placeholder image area + social icons-box-ac-12

import React from 'react';

import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

export default function AboutUsCard13() {
  return (<>
    <section className="mot-sec-ac-12">
      <div className="mot-left-ac-12">
        <h5 className="sup-ac-12">ABOUT</h5>
        <h2 className="title-ac-12">Your Name Here</h2>
        <h4 className="sub-ac-12">AUTHOR, MOTIVATIONAL SPEAKER</h4>

        <p className="desc-ac-12">
          Replace this content with your own biography. Share a powerful mission statement, achievements,
          and a short overview of your expertise.
        </p>
        <p className="desc-ac-12">
          Add a more detailed desc-ac-12ription here about your work, purpose, and contributions to inspire
          your audience and build trust.
        </p>

        <div className="social-box-ac-12">
          <span>Follow us on:</span>
          <div className="icons-box-ac-12">
          <a><FaFacebookF /></a><a><FaTwitter /></a><a> <FaInstagram /></a><a><FaLinkedinIn /></a><a><FaYoutube /></a>  
                        
                       
                        
                        
          </div>
        </div>
      </div>

      <div className="mot-right-box-ac-12">
        <div className="img-placeholder-box-ac-12"><img src="https://i.postimg.cc/NjF4BFVz/red_haired_lady_eyeglasses_holds_books_shows_ok_sign_1_removebg_preview.png"/></div>
      </div>
    </section>
    <style>{`
/* File: MotivationalAboutSection.css */

.mot-sec-ac-12 {
  display: flex;margin-top:50px;
  padding: 80px 60px;
  background: #0e0e0e;
  color: #fff;
  font-family: Inter, sans-serif;
  gap: 50px;
  align-items: center;
}

/* LEFT */
.mot-left-ac-12 {
  flex: 1.1;
}

.sup-ac-12 {
  font-size: 14px;
  opacity: 0.8;
  margin-bottom: 10px;
}

.title-ac-12 {
  font-size: 40px;
  font-weight: 800;
  color: rgba(144, 202, 249,1);
}

.sub-ac-12 {
  font-size: 16px;
  font-weight: 600;
  opacity: 0.9;
  margin: 10px 0 30px;
}

.desc-ac-12 {
  line-height: 1.7;
  font-size: 15px;
  color: #ccc;
  margin-bottom: 18px;
  max-width: 520px;
}

.social-box-ac-12 {
  background: rgba(255,255,255,0.05);
  padding: 14px 18px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  gap: 14px;
  margin-top: 25px;
}

.icons-box-ac-12 {display:flex;gap:15px;
}
.icons-box-ac-12 a {
  cursor: pointer;
  font-size: 20px;
}

/* RIGHT */
.mot-right-box-ac-12 {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle, rgba(144, 202, 249,0.51) 0%, rgba(14,14,14,1) 70%);
  border-radius: 360px 360px 0 0;
  padding: 40px;
}

.img-placeholder-box-ac-12 {
  width: 300px;
  height: 420px;
  
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255,255,255,0.6);
  font-size: 18px;
  text-align: center;
}

/* Responsive */
@media(max-width:960px){
  .mot-sec-ac-12 {
    flex-direction: column;
    text-align: center;padding: 50px 10px;
  }
  .desc-ac-12 {
    max-width: 100%;
  }
  .mot-right-box-ac-12 {
    width: 100%;
    border-radius: 200px;
  }
}`}</style>
    </>
  );
}
